<template lang="pug">
v-dialog(
  :width='width'
  dark
  v-model='dialog'
  persistent
  transition="dialog-bottom-transition"
)
  v-card.pa-5
    div.align-center.d-flex.mb-4
      v-icon.mr-2 mdi-information-outline
      p.mb-0.text-h6 {{ title }}
    div.mb-4(v-if="message" v-html="message")
    template(v-if='!!$slots.default')
      v-form(v-model="valid" ref="form")
        slot
    v-card-actions.pa-0
      v-btn.mr-auto(
        :disabled="!valid"
        :loading="loading"
        color='success'
        @click='accept'
      ) {{ acceptBtnText }}
      v-btn(
        text
        @click='decline'
      ) {{ cancelBtnText }}
</template>

<script>
export default {
  props: {
    value: {
      type:Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: 'Подтвердите действие',
    },
    message: {
      type: String,
      required: false,
      default: '',
    },
    metaInfo: {
      type: Object,
      required: false,
      default: () => {},
    },
    width: {
      required: false,
      type: String,
      default: '420px',
    },
    acceptBtnText: {
      type: String,
      required: false,
      default: 'Подтвердить',
    },
    cancelBtnText: {
      type: String,
      required: false,
      default: 'Отмена',
    },
    loading:{
      type:Boolean,
      required:false,
      default:false,
    },
  },
  data() {
    return {
      dialog: false,
      valid: true,
    };
  },
  watch:{
    value:{
      immediate: true,
      handler(v) {
        this.dialog = v;
      },
    },
    dialog :{
      immediate: true,
      handler(v) {
        this.dialog = v;
        this.$emit('input', v);
      },
    },
  },
  methods: {
    decline() {
      this.$emit('decline');
      this.dialog  = false;
    },
    accept() {
      this.$emit('accept', this.metaInfo);
      this.dialog  = false;
    },
  },
};
</script>
